export default {

    init() {
            let heatpumpform = document.getElementById('heatPump-form');
            if(!(heatpumpform)){
                return;
            }
            const totalString = '(avbetaling over strømregningen over 5 år: kr {monthly} pr. mnd. inkl. renter / totalpris kr {total}) ';
            const years = 5;
            const interestRate = 8.8;
            let fillPriceFields = document.querySelectorAll('[data-fill-price]');
            let calculateSumFields = document.querySelectorAll('[data-calculate-sum]');
            Number.prototype.formatMoney = function (decimalAmount, decimalSeparator, thousandsSeparator) {
                var _number = this;
                var _decimalAmount = isNaN(decimalAmount = Math.abs(decimalAmount)) ? 2 : decimalAmount;
                var _decimalSeparator = (decimalSeparator === undefined) ? "," : decimalSeparator;
                var _thousandsSeparator = (thousandsSeparator === undefined) ? " " : thousandsSeparator;
                var _numberPrefix = (_number < 0) ? "-" : ""; var _intBeforeDecimals = parseInt(_number = Math.abs(+_number ||
                    0).toFixed(_decimalAmount)) + ""; var _modulo = (_intBeforeDecimals.length > 3) ? _intBeforeDecimals.length % 3 : 0;
                return _numberPrefix +
                    (_modulo ? _intBeforeDecimals.substr(0, _modulo) + _thousandsSeparator : "") +
                    _intBeforeDecimals.substr(_modulo).replace(/(\d{3})(?=\d)/g, "$1" + _thousandsSeparator) +
                    (_decimalAmount ? _decimalSeparator + Math.abs(_number - _intBeforeDecimals).toFixed(_decimalAmount).slice(2) : "");
            };
            var getAnnuity = function (interestRate, amountOfMonths, sum) {
                return (interestRate * sum * Math.pow((1 + interestRate), amountOfMonths) / (1 - Math.pow((1 + interestRate),
                    amountOfMonths)));
            };
            var calculateMonthlyInstallment = function (price, years, yearlyInterestRate) {
                var productPrice = parseFloat(price);
                var amountOfYears = parseFloat(years);
                var amountOfMonths = parseFloat(12);
                var interestRate = parseFloat(yearlyInterestRate);
                var annuity = getAnnuity(((interestRate / amountOfMonths) / 100), (amountOfMonths * amountOfYears), productPrice);
                var interest = (productPrice * (interestRate / amountOfMonths)) / 100;
                var installment = annuity - interest;
                return parseFloat(Math.abs(Math.round(parseFloat((installment + interest).toFixed(2)))));
            };
            var getPrice = function (type, amount) {
                var price = 0;
                price =  type.getAttribute('data-val');
                return parseFloat(amount * price);
            };
            Array.prototype.forEach.call(fillPriceFields, function (el) {
                var getPriceFor = el.getAttribute('data-fill-price-for');
                var getPriceForEl = document.querySelector('#' + getPriceFor);
                el.value = getPrice(getPriceForEl, getPriceForEl.value > -1 ? 1 : 0).formatMoney().replace(',00', ',-');
                getPriceForEl.addEventListener('change', function () {
                    var id = this.id;
                    var priceFieldEl = document.querySelector('[data-fill-price-for="' + id + '"]');
                    priceFieldEl.value = getPrice(this, this.value > -1 ? 1 : 0).formatMoney().replace(',00', ',-');
                });
            });
            Array.prototype.forEach.call(calculateSumFields, function (el) {
                var calculateSumFor = el.getAttribute('data-calculate-sum-from');
                var calculateSumForEl = document.querySelector('#' + calculateSumFor);
                el.value = getPrice(calculateSumForEl, parseInt(calculateSumForEl.value)).formatMoney().replace(',00', ',-');
                calculateSumForEl.addEventListener('change', function () {
                    var id = this.id;
                    var sumFieldEl = document.querySelector('[data-calculate-sum-from="' + id + '"]');
                    var price = getPrice(this, parseInt(this.value));
                    var totalFieldEl = document.querySelector('[data-total-for="' + sumFieldEl.id + '"]');
                    if (totalFieldEl) {
                        var monthlyInstallment = calculateMonthlyInstallment(price, years, interestRate);
                        var totalPrice = monthlyInstallment * (years * 12);
                        totalFieldEl.value = totalString.replace('{monthly}', monthlyInstallment.formatMoney().replace(',00', ',-'))
                            .replace('{total}', totalPrice.formatMoney().replace(',00', ',-'));
                        totalFieldEl.setAttribute('data-monthly', monthlyInstallment.toString());
                        totalFieldEl.setAttribute('data-total', totalPrice.toString());
                        var grandTotalFieldEl = document.querySelector('[data-grand-total]');
                        if (grandTotalFieldEl) {
                            var elements = document.querySelectorAll('[data-total-for]');
                            var monthlyTotal = 0;
                            var grandTotal = 0;
                            Array.prototype.forEach.call(elements, function (el) {
                                var monthly = parseFloat(el.getAttribute('data-monthly'));
                                var total = parseFloat(el.getAttribute('data-total'));
                                if (monthly) {
                                    monthlyTotal += monthly;
                                }
                                if (total) {
                                    grandTotal += total;
                                }
                            });
                            grandTotalFieldEl.value = totalString.replace('{monthly}', monthlyTotal.formatMoney().replace(',00', ',-'))
                                .replace('{total}', grandTotal.formatMoney().replace(',00', ',-'));
                        }
                    }
                    sumFieldEl.value = price.formatMoney().replace(',00', ',-');
                });
            });
            var otherModelsSumFieldEl = document.querySelector('#otherModelsSum');
            if (otherModelsSumFieldEl) {
                otherModelsSumFieldEl.addEventListener('change', function () {
                    var totalFieldEl = document.querySelector('[data-total-for="' + this.id + '"]');
                    if (totalFieldEl) {
                        var monthlyInstallment = calculateMonthlyInstallment(this.value, years, interestRate);
                        var totalPrice = monthlyInstallment * (years * 12);
                        totalFieldEl.value = totalString.replace('{monthly}', monthlyInstallment.formatMoney().replace(',00', ',-'))
                            .replace('{total}', totalPrice.formatMoney().replace(',00', ',-'));
                        totalFieldEl.setAttribute('data-monthly', monthlyInstallment.toString());
                        totalFieldEl.setAttribute('data-total', totalPrice.toString());
                        var grandTotalFieldEl = document.querySelector('[data-grand-total]');
                        if (grandTotalFieldEl) {
                            var elements = document.querySelectorAll('[data-total-for]');
                            var monthlyTotal = 0;
                            var grandTotal = 0;
                            Array.prototype.forEach.call(elements, function (el) {
                                var monthly = parseFloat(el.getAttribute('data-monthly'));
                                var total = parseFloat(el.getAttribute('data-total'));
                                if (monthly) {
                                    monthlyTotal += monthly;
                                }
                                if (total) {
                                    grandTotal += total;
                                }
                            });
                            grandTotalFieldEl.value = totalString.replace('{monthly}', monthlyTotal.formatMoney().replace(',00', ',-'))
                                .replace('{total}', grandTotal.formatMoney().replace(',00', ',-'));
                        }
                    }
                    this.value = this.value.formatMoney().replace(',00', ',-');
                });
            }
    }
}